import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
export const BoardHeader = ({ boardId, title, description, onTitleChange, onDescriptionChange, onOpenBoardInfo, isDark, }) => {
    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [editingTitle, setEditingTitle] = useState(title);
    const [isEditingDescription, setIsEditingDescription] = useState(false);
    const [editingDescription, setEditingDescription] = useState(description);
    const [showDropdown, setShowDropdown] = useState(false);
    const titleInputRef = useRef(null);
    const descriptionInputRef = useRef(null);
    useEffect(() => {
        setEditingTitle(title);
    }, [title]);
    useEffect(() => {
        setEditingDescription(description);
    }, [description]);
    useEffect(() => {
        if (isEditingTitle && titleInputRef.current) {
            titleInputRef.current.focus();
            titleInputRef.current.select();
        }
    }, [isEditingTitle]);
    useEffect(() => {
        if (isEditingDescription && descriptionInputRef.current) {
            descriptionInputRef.current.focus();
            descriptionInputRef.current.select();
        }
    }, [isEditingDescription]);
    const handleTitleSave = () => {
        const trimmedTitle = editingTitle.trim();
        if (trimmedTitle && trimmedTitle !== title) {
            onTitleChange(trimmedTitle);
        }
        else {
            setEditingTitle(title);
        }
        setIsEditingTitle(false);
    };
    const handleTitleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleTitleSave();
        }
        else if (e.key === 'Escape') {
            setEditingTitle(title);
            setIsEditingTitle(false);
        }
    };
    const handleDescriptionSave = () => {
        const trimmedDescription = editingDescription.trim();
        if (trimmedDescription !== description) {
            onDescriptionChange(trimmedDescription);
        }
        else {
            setEditingDescription(description);
        }
        setIsEditingDescription(false);
    };
    const handleDescriptionKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleDescriptionSave();
        }
        else if (e.key === 'Escape') {
            setEditingDescription(description);
            setIsEditingDescription(false);
        }
    };
    const displayDescription = description || 'Write description here...';
    return (_jsx("div", { className: "px-6 py-4 border-b", style: {
            borderColor: isDark ? '#333333' : '#e5e7eb',
            backgroundColor: isDark ? '#1a1a1a' : '#ffffff'
        }, children: _jsxs("div", { className: "flex items-center justify-between gap-4", children: [_jsxs("div", { className: "flex-1 min-w-0", children: [isEditingTitle ? (_jsx("input", { ref: titleInputRef, type: "text", value: editingTitle, onChange: (e) => setEditingTitle(e.target.value), onBlur: handleTitleSave, onKeyDown: handleTitleKeyDown, className: "text-2xl font-bold w-full px-2 py-1 rounded border", style: {
                                color: isDark ? '#ffffff' : '#000000',
                                backgroundColor: isDark ? '#2a2a2a' : '#f9fafb',
                                borderColor: isDark ? '#444444' : '#d1d5db'
                            } })) : (_jsx("h1", { className: "text-2xl font-bold cursor-pointer px-2 py-1 rounded hover:bg-opacity-50 transition-colors", onClick: () => setIsEditingTitle(true), style: {
                                color: isDark ? '#ffffff' : '#000000'
                            }, children: title })), isEditingDescription ? (_jsx("input", { ref: descriptionInputRef, type: "text", value: editingDescription, onChange: (e) => setEditingDescription(e.target.value), onBlur: handleDescriptionSave, onKeyDown: handleDescriptionKeyDown, className: "text-sm w-full px-2 py-1 rounded border", style: {
                                color: isDark ? '#ffffff' : '#000000',
                                backgroundColor: isDark ? '#2a2a2a' : '#f9fafb',
                                borderColor: isDark ? '#444444' : '#d1d5db'
                            }, placeholder: "Add a description..." })) : (_jsx("p", { className: "text-sm cursor-pointer px-2 py-1 rounded hover:bg-opacity-50 transition-colors mt-1", onClick: () => setIsEditingDescription(true), style: {
                                color: isDark ? '#888888' : '#6b7280'
                            }, children: displayDescription }))] }), _jsxs("div", { className: "relative", children: [_jsx("button", { onClick: () => setShowDropdown(!showDropdown), className: "p-2 rounded-lg hover:bg-opacity-50 transition-colors", style: {
                                backgroundColor: isDark ? '#2a2a2a' : '#f3f4f6'
                            }, title: "Board info", children: _jsx(ChevronDown, { className: "w-5 h-5", style: { color: isDark ? '#ffffff' : '#000000' } }) }), showDropdown && (_jsx("div", { className: "absolute right-0 mt-2 w-48 rounded-lg shadow-lg border z-50", style: {
                                backgroundColor: isDark ? '#2a2a2a' : '#ffffff',
                                borderColor: isDark ? '#444444' : '#e5e7eb'
                            }, children: _jsx("button", { onClick: () => {
                                    onOpenBoardInfo();
                                    setShowDropdown(false);
                                }, className: "w-full text-left px-4 py-2 first:rounded-t-lg hover:bg-opacity-50 transition-colors flex items-center gap-2", style: {
                                    color: isDark ? '#ffffff' : '#000000',
                                    backgroundColor: isDark ? '#333333' : '#f3f4f6'
                                }, children: _jsx("span", { children: "Board info" }) }) }))] })] }) }));
};
